import axios from 'axios';
import { request_mutations, request_state } from '../utils/store';
import { SIGNUP, RESEND_CONFIRMATION } from '../api';

export default {
    namespaced: true,
    state: {
        signup: request_state(),
        resend: request_state(),
    },
    mutations: {
        ...request_mutations('signup', 'signup'),
        ...request_mutations('resend', 'resend'),
    },
    actions: {
        signup({ commit }, payload) {
            commit('signup_loading');
            return new Promise((resolve) => {
                axios.post(SIGNUP, payload).then((response) => {
                    commit('signup_success', response.data);
                    resolve(response.data);
                }).catch(error => commit('signup_error', error.response.data));
            });
        },
        resend({ commit }, user_id) {
            const url = RESEND_CONFIRMATION.replace('{user_id}', user_id);

            commit('resend_loading');
            return new Promise((resolve) => {
                axios.post(url).then((response) => {
                    commit('resend_success', response.data);
                    resolve(response.data);
                }).catch(error => commit('resend_error', error.response.data));
            });
        },
    },
};
